import IMask from 'imask'

export default (el, { expression }, { evaluateLater, effect }) => {
  const getMaskConfig = evaluateLater(expression)

  el.addEventListener('input', () => {
    effect(() => {
      getMaskConfig((maskConfig) => {
        const masked = IMask.createMask(maskConfig)

        masked.resolve(el.value)
        el.value = masked.value
      })
    })
  })
}
